import { Box } from '@chakra-ui/react';
import './index.css';
import classNames from 'classnames';

export function CommonBox({ children, className }: { children?: React.ReactNode; className?: string }) {
  return <Box className={classNames('box', className)}>{children}</Box>;
}
